import { render, staticRenderFns } from "./TermsModal.vue?vue&type=template&id=cd889034&"
import script from "./TermsModal.vue?vue&type=script&lang=ts&"
export * from "./TermsModal.vue?vue&type=script&lang=ts&"
import style0 from "./TermsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports